import React, { Component } from 'react';
import styled, { css, keyframes } from 'styled-components';
import { Formik, Field } from 'formik';
import Button from '../../components/Button';
import * as Yup from 'yup';
import FlightCheckbox from '../../components/FlightCheckbox';
import LoadMask from '../../components/LoadMask';
import { azulPost } from '../../services';
import { devices } from '../../styles/breakpoints';
// import { mockPost } from '../../consts/MOCK_DATA';

const FieldContainer = styled.div`
  margin-bottom: 14px;
`;

const ActionContainer = styled.div`
  position: fixed;
  bottom: 0px;
  width: 100%;
  left: 0px;
  padding: 16px 16px 0;
  background-color: white;
  box-shadow: 0 -1px 2px 1px rgba(0, 0, 0, 0.15);

  @media ${devices.desktop} {
    position: relative;
    width: 290px;
    margin: 0 auto;
    background-color: none;
    box-shadow: none;
  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const fadeInMixin = css`
  animation: ${fadeIn} ${({ itemOrder }) => (itemOrder + 1) * 0.3}s;
`;

const StyledCheckbox = styled(FlightCheckbox)`
  ${fadeInMixin};
`;

const Form = styled.form`
  padding-bottom: 90px;

  @media ${devices.desktop} {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    max-width: 760px;
    margin: 0 auto;
    padding-bottom: 0;

    ${FieldContainer} {
      flex-basis: 48%;
    }
  }
`;

export default class FlightChangeForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowingOtherFlights: false,
      showOtherFlights: false,
      isLoading: false,
      error: ''
    };
  }

  componentDidMount() {}

  _getValidations = () => {
    return Yup.object().shape({
      selectedFlight: Yup.object().required()
    });
  };

  _setIsShowingOtherFlights = () => {
    this.setState({ isShowingOtherFlights: true });
    setTimeout(() => {
      this.setState({ showOtherFlights: true });
    }, 600);
  };

  _renderCheckboxList = () => {
    return this.props.flights.map((flight, index) => (
      <FieldContainer key={index}>
        <Field
          name={'selectedFlight'}
          label="Código da Reserva"
          placeholder="Digite o código"
          type="text"
          component={StyledCheckbox}
          flight={flight}
          errorMessage="Campo obrigatório"
          isRequired={true}
          format={value => value}
          parse={value => value}
          onChange={value => value}
          value={flight}
          onBlur={value => value}
          itemOrder={index}
          key={index}
        />
      </FieldContainer>
    ));
  };

  _onSubmit = async ({ selectedFlight }) => {
    const { onLoading, pnr } = this.props;

    const reqBody = {
      recordLocator: pnr,
      selectedNewJourneySellKey: selectedFlight.journeySellKey
    };

    onLoading(true);

    try {
      const response = await azulPost(
        '/SelfService/ConfirmIropSelfService',
        reqBody
      );

      // const response = await mockPost();

      const { success, data, notifications } = response;

      if (success) {
        this._handlePostSuccess(data, pnr);
      } else {
        this._handlePostError(notifications[0].value);
      }
    } catch (error) {
      console.log(error.message);
      this.setState({ error: error.message });
      onLoading(false);
    }
  };

  _handlePostSuccess = (flight, pnr) => {
    const { history } = this.props;

    return history.push('flight-confirmation', { pnr, flight });
  };

  _handlePostError = error => {
    const { onLoading } = this.props;
    onLoading(false);

    this.setState({ error });
  };

  render() {
    const { isLoading } = this.state;

    if (isLoading) return <LoadMask />;

    return (
      <Formik
        initialValues={{
          selectedFlight: ''
        }}
        validationSchema={this._getValidations}
        onSubmit={this._onSubmit}
        validateOnMount
      >
        {({ resetForm, values, handleSubmit, isValid }) => {
          return (
            <Form
              onSubmit={e => {
                e.stopPropagation();
                e.preventDefault();
                handleSubmit();
              }}
            >
              {this._renderCheckboxList()}
              <ActionContainer>
                <Button type="submit" success disabled={!isValid}>
                  Confirmar Voo
                </Button>
              </ActionContainer>
            </Form>
          );
        }}
      </Formik>
    );
  }
}
